// extracted by mini-css-extract-plugin
export default {"welcome-header":"welcome-header_welcome-header__kPsWl"};